import React, {Component} from "react";
import {Button, Modal, Form} from "react-bootstrap";

/**
 * 二要素認証（メールOTP）無効化の確認モーダル（Issue #443）
 *
 * 無効化は第2要素を外す操作のため、サーバ側（/User/updateMfaOff）が
 * パスワードの再入力を必須にしている。セッションを奪われた状態で無効化されると
 * 乗っ取りが永続化するため、この画面で操作者本人のパスワードを受け取る。
 *
 * props:
 *   show: boolean
 *   userId: string 対象ユーザーID（サブユーザーが対象ならサブユーザーID）
 *   password: string 操作者のパスワード
 *   isExecuting: boolean 実行中
 *   langText: langTextオブジェクト
 *   onChangePassword: (value) => void
 *   onHide: () => void
 *   onExecute: () => void
 */
export default class UserMfaOffModal extends Component {
    render() {
        let {
            show, userId, password, isExecuting, langText,
            onChangePassword, onHide, onExecute
        } = this.props;

        return (
            <Modal show={show} onHide={onHide} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{langText.Body.MfaOffTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{langText.Body.MfaOffConfirmMessage.replace("{0}", userId)}</p>
                    <Form.Group controlId="mfaOffPassword">
                        <Form.Label>{langText.Body.MfaOffPasswordLabel}</Form.Label>
                        <Form.Control
                            type="password"
                            autoComplete="current-password"
                            value={password || ""}
                            onChange={e => onChangePassword(e.target.value)}
                        />
                        <Form.Text className="text-muted">
                            {langText.Body.MfaOffPasswordNote}
                        </Form.Text>
                    </Form.Group>
                    <p className="text-muted">{langText.Body.MfaOffNote}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        disabled={!password || isExecuting}
                        onClick={() => onExecute()}
                    >
                        {isExecuting ? langText.Body.Wait : langText.Body.MfaOffButton}
                    </Button>
                    <Button variant="secondary" onClick={onHide}>
                        {langText.Body.Cancel}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
